import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 18726 17819"
    {...props}
  >
    <defs>
      <style>{".fil0{fill:#343230}"}</style>
    </defs>
    <g id="Layer_x0020_1">
      <path
        d="M585 16024h17555v-2716c0-847-688-1536-1536-1536l-14483-1c-846 0-1536 690-1536 1537v2716zm17848 585H292c-161 0-292-131-292-292v-3009c0-1170 951-2121 2121-2121h14483c1170 0 2122 951 2122 2121v3009c0 161-131 292-293 292z"
        className="fil0"
      />
      <path
        d="M1795 17233h624v-624h-624v624zm916 586H1502c-162 0-293-131-293-293v-1209c0-162 131-293 293-293h1209c162 0 293 131 293 293v1209c0 162-131 293-293 293zM16307 17233h624v-624h-624v624zm917 586h-1210c-161 0-292-131-292-293v-1209c0-162 131-293 292-293h1210c161 0 292 131 292 293v1209c0 162-131 293-292 293zM2701 11187h13323V2701h-624v918c0 161-131 292-293 292h-3023c-162 0-293-131-293-292v-918h-1521c-162 0-293-131-293-292v-916H8748v916c0 161-131 292-292 292H6934v918c0 161-131 292-293 292H3619c-162 0-293-131-293-292v-918h-625v8486zm13615 584H2409c-162 0-293-130-293-291V2409c0-162 131-292 293-292h1210c161 0 292 130 292 292v917h2438v-917c0-162 131-292 292-292h1522v-917c0-162 131-293 293-293h1814c161 0 293 131 293 293v917h1521c161 0 292 130 292 292v917h2439v-917c0-162 131-292 292-292h1209c162 0 293 130 293 292v9070c0 162-131 293-293 293v-1z"
        className="fil0"
      />
      <path
        d="M2409 2701c-162 0-293-131-293-292v-907c0-162 131-292 293-292 161 0 292 130 292 292v907c0 161-131 292-292 292zM16316 2701c-161 0-292-131-292-292v-907c0-162 131-292 292-292 162 0 293 130 293 292v907c0 161-131 292-293 292zM4213 11187h3648V9353H4213v1834zm3940 584H3921c-162 0-293-130-293-291V9061c0-163 131-293 293-293h4232c162 0 293 130 293 293v2418c0 162-131 293-293 293v-1zM11167 11187h3648V9353h-3648v1834zm3940 584h-4232c-162 0-293-130-293-291V9061c0-163 131-293 293-293h4232c162 0 293 130 293 293v2418c0 162-131 293-293 293v-1zM9363 1493c-162 0-293-132-293-293V293c0-162 131-293 293-293 161 0 292 131 292 293v907c0 161-131 293-292 293zM8922 4474l441 441 441-441-441-442-441 442zm441 1147c-77 0-152-31-207-86l-855-855c-115-114-115-299 0-413l855-856c55-54 130-85 207-85 78 0 152 31 207 85l855 856c114 114 114 299 0 413l-855 855c-55 55-130 86-207 86zM4818 5744h624v-624h-624v624zm917 586H4526c-162 0-293-131-293-293V4827c0-161 131-292 292-292h1210c161 0 292 131 292 292v1210c0 162-131 293-292 293zM13284 5744h624v-624h-624v624zm916 586h-1209c-162 0-293-131-293-293V4827c0-161 131-292 293-292h1209c161 0 293 131 293 292v1210c0 162-132 293-293 293z"
        className="fil0"
      />
    </g>
  </svg>
)
export default SvgComponent
